import { withRouter } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import PaymentForm from './paymentForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const stripeOptions = { locale: 'pt-BR' }

const Payment = () => (
  <Elements stripe={stripePromise} options={stripeOptions}>
    <PaymentForm />
  </Elements>
)

export default withRouter(Payment);
